import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { PublicStore } from './store/public.store';
import { DatePipe } from '@angular/common';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-public',
  imports: [RouterOutlet, ToastModule],
  templateUrl: './public.html',
  styleUrl: './public.scss',
  providers: [PublicStore, DatePipe, MessageService],
})
export class Public {

}
